import React from "react";
import "./Announcement.css";


const AnnouncementBar = () => {
return (
<div className="announcement-wrapper">
<div className="announcement-label">
उपक्रम आणि कार्यक्रम
</div>


<div className="announcement-marquee-wrapper">
<div className="announcement-marquee">
<span className="announcement-text">स्थापना ०६/०१/२००९ | शासनमान्य दर्जा ड | नोंदणी क्र. महा/२५५८६/कोल्हापूर |</span>
<span className="announcement-text">
महाराष्ट्र शासन – डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय पुरस्कार प्राप्त.
</span>
</div>
</div>
</div>
);
};


export default AnnouncementBar;